import React, { useRef, useState } from 'react';
import { TableEditButtons, usePaginatedQueryV8 } from 'motion-components';
import { Card } from 'react-bootstrap';
import { FlexRow } from 'motion-components';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { DataGrid } from './grid';
import { handleExport } from './export-columns';
import { useApolloClient } from '@apollo/client';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserLocationPermissions } from 'shared-pages/hooks';
import { CpWasteCategoriesTitle } from 'shared-pages/common/constants';

/** CRUD σελίδα κατηγοριών αποβλήτων σημείων συλλογής */
export const CpWasteCategoriesGridPage = () => {
  const { appStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('CpWasteCategoriesGridPage');

  const location = useLocation<any>();
  const history = useHistory();
  const [selected, setSelected] = useState<any>(null);
  const { t } = useTranslation();

  const { canAddNew } = useUserLocationPermissions();

  const initOrderBy = 'name ASC';
  const query = usePaginatedQueryV8(
    gqlGetQuery,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    true,
    { isActive: true },
  );
  const {
    loading,
    data,
    dataCount,
    error,
    initPageIndex,
    filtersChanged,
    gridPageChanged,
    queryState,
    queryParams,
    setQueryParams,
    refetch,
  } = query;

  const client = useApolloClient();
  const gridRef = useRef();

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  } else {
    return (
      <Card className="shadow">
        <Card.Header>
          <FlexRow>
            <Card.Title className="m-0">{t(CpWasteCategoriesTitle)}</Card.Title>
            <TableEditButtons
              className="me-3"
              canEdit={true}
              canInsert={canAddNew}
              canDelete={true}
              tableOptionsMeta={() => {
                if (gridRef.current) return (gridRef.current as any).table.options.meta;
                else return undefined;
              }}
              twoLines={false}
            />
          </FlexRow>
        </Card.Header>
        <Card.Body className="nopadding">
          <Filters onChange={filtersChanged} initialValues={queryState?.filterValues ?? {}} />
          <DataGrid
            ref={gridRef}
            loading={loading}
            data={data}
            refetch={refetch}
            dataCount={dataCount}
            initPageIndex={initPageIndex}
            onPageChange={gridPageChanged}
            handleExport={() => {
              handleExport(client, queryState, t);
            }}
            initOrderBy={queryParams?.order ?? initOrderBy}
            onOrderChange={(orderBy) => {
              const newQueryParams = { ...queryParams, order: orderBy };
              setQueryParams(newQueryParams);
              history.replace({
                pathname: location.pathname,
                state: {
                  ...location.state,
                  order: orderBy,
                },
              });
            }}
            selected={selected}
            setSelected={setSelected}
          />
        </Card.Body>
      </Card>
    );
  }
};
